import React from 'react';
import PropTypes from 'prop-types';

const PrimaryButton = React.forwardRef(({
  text, onClick, isDisabled, loading, className,
}, ref) => (
  <button
    data-testid="submit_product_in_popup_btn"
    className={`btn btn-primary w-100 py-3 position-relative ${className}`}
    type="button"
    ref={ref}
    onClick={onClick}
    disabled={isDisabled || loading}
  >
    <span dangerouslySetInnerHTML={{ __html: text }} />
    {loading && (
    <span
      className="spinner-border spinner-border-sm "
      role="status"
      aria-hidden="true"
      style={{ position: 'absolute', top: '16px', right: '16px' }}
    />
    )}
  </button>
));

PrimaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

PrimaryButton.defaultProps = {
  onClick: () => {
  },
  isDisabled: false,
  loading: false,
  className: '',
};

export default PrimaryButton;
